import isEmpty from 'lodash/isEmpty';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import PageError from 'pages/404';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { useResponsive } from 'src/utils/device';
import styled from 'styled-components';
import { KEY_ADS_POSITION } from '../ads/dynamic-ads';
import HeadingTag, { KEY_HEADING_TAG } from '../heading/heading-tag';
import { useState } from 'react';

const DynamicAds = dynamic(
  () => import('../ads/dynamic-ads'),
  { ssr: false }
);
const CardV = dynamic(() => import('src/components/cards/card-v'));

const GalleryLasted = (data) => {
  const { articles, ads } = data;
  const responsive = useResponsive();
  const router = useRouter();
  const dataGallery = articles;
  const [closeAd, setCloseBoxAd] = useState(true);

  const handleCloseBoxAd = () => {
    setCloseBoxAd(false);
  };
  if (!Array.isArray(dataGallery)) {
    console.error('dataGallery is not an array');
    return <PageError />;
  }
  const rectangleA = !isEmpty(ads.find(el => el.position === 'rectangle-a'));
  const rectangleB = !isEmpty(ads.find(el => el.position === 'rectangle-b'));
  const dataSection1 = responsive?.isMobile ? articles?.slice(0, 6) : articles?.slice(0, 8);
  const dataSection2 = responsive?.isMobile ? articles?.slice(6, 12) : (rectangleA ? articles?.slice(8, 15) : articles?.slice(8, 16));
  const dataSection3 = responsive?.isMobile ? articles?.slice(12, 18) : (rectangleB ? articles?.slice(15, 22) : articles?.slice(16, 24));
  const dataSection4 = responsive?.isMobile ? articles?.slice(18) : articles?.slice(24);
  // console.log('data : ', data);
  return (
    <>
      <GalleriesWrapper id='section-1' className='main-content'>
        <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />
        <div className='container-content grid-wrapper '>
          <div className={'section-title'}>
            <HeadingTag
              heading={'รวมอัลบั้มรูปล่าสุด'}
              type={KEY_HEADING_TAG.SECTION_SECTION}
              path={null}
            />
          </div>
          <div className='album'>
            <div className='responsive-container-block bg'>
              {!isEmpty(dataSection1) &&
                dataSection1.map((item, index) => {
                  return (
                    <div key={index} className='responsive-image'>
                      <CardV
                        showBlurb={false}
                        showFooter={false}
                        path={`/galleries/${item.id}`}
                        data={{
                          ...item,
                          image: dataSection1[index]?.image ?? item.data?.[index]?.file,
                          link: `/galleries/${item.id}`
                        }}
                        external={false}
                        // ! DATALAYER
                        sendPageview={
                          {
                            category: `อัลบั้ม : ${item.title}`,
                            author: item?.created_by,
                            keyword: `${item.tags}`,
                            createdAt: `${item.created_at}`
                          }
                        }
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'section-1',
                          position: 'ใต้:ads-billboard',
                          data: {
                            block: '1',
                            title: `อัลบั้ม : ${item.title}`,
                            heading: 'รวมอัลบั้มรูปล่าสุด',
                            index: index + 1
                          }
                        }}
                      />
                    </div>
                  );
                })}
              <DynamicAds position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />
            </div>
            <div className='responsive-container-block bg'>
              {!isEmpty(dataSection2) &&
                dataSection2.map((item, index) => {
                  return (
                    <>
                      {!responsive?.isMobile && (rectangleA && index === 3) && <DynamicAds position={KEY_ADS_POSITION.RECTANGLE_A} data={ads} />}
                      <div key={index} className='responsive-image'>
                        <CardV
                          external={false}
                          showBlurb={false}
                          showFooter={false}
                          data={{
                            ...item,
                            image: dataSection2[index]?.image ?? item.data?.[index]?.file,
                            link: `/galleries/${item.id}`
                          }}
                          // ! DATALAYER
                          sendPageview={
                            {
                              category: `อัลบั้ม : ${item.title}`,
                              author: item?.created_by,
                              keyword: `${item.tags}`,
                              createdAt: `${item.created_at}`
                            }
                          }

                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'section-1',
                            position: 'ใต้:ads-billboard',
                            data: {
                              block: '1',
                              title: `อัลบั้ม : ${item.title}`,
                              heading: 'รวมอัลบั้มรูปล่าสุด',
                              index: index + 1
                            }
                          }}
                        />
                      </div>
                    </>
                  );
                })}
            </div>
            <DynamicAds position={KEY_ADS_POSITION.INARTICLE_2} data={ads} />
            <div className='responsive-container-block bg'>
              {!isEmpty(dataSection3) &&
                dataSection3.map((item, index) => {
                  return (
                    <>
                      {!responsive?.isMobile && (rectangleB && index === 3) && <DynamicAds position={KEY_ADS_POSITION.RECTANGLE_B} data={ads} />}
                      <div key={index} className='responsive-image'>
                        <CardV
                          showBlurb={false}
                          showFooter={false}
                          path={`/galleries/${item.id}`}
                          data={{
                            ...item,
                            image: dataSection3[index]?.image ?? item.data?.[index]?.file,
                            link: `/galleries/${item.id}`
                          }}
                          external={false}
                          // ! DATALAYER
                          sendPageview={
                            {
                              category: `อัลบั้ม : ${item.title}`,
                              author: item?.created_by,
                              keyword: `${item.tags}`,
                              createdAt: `${item.created_at}`
                            }
                          }

                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'section-1',
                            position: 'ใต้:ads-billboard',
                            data: {
                              block: '1',
                              title: `อัลบั้ม : ${item.title}`,
                              heading: 'รวมอัลบั้มรูปล่าสุด',
                              index: index + 1
                            }
                          }}
                        />
                      </div>
                    </>
                  );
                })}
            </div>
            <DynamicAds position={KEY_ADS_POSITION.INARTICLE_3} data={ads} />
            <div className='responsive-container-block bg'>
              {!isEmpty(dataSection4) &&
                dataSection4.map((item, index) => {
                  return (
                    <div key={index} className='responsive-image'>
                      <CardV
                        showBlurb={false}
                        showFooter={false}
                        data={{
                          ...item,
                          image: dataSection4[index]?.image ?? item.data?.[index]?.file,
                          link: `/galleries/${item.id}`
                        }}
                        path={`/galleries/${item.id}`}
                        external={false}
                        // ! DATALAYER
                        sendPageview={
                          {
                            category: `อัลบั้ม : ${item.title}`,
                            author: item?.created_by,
                            keyword: `${item.tags}`,
                            createdAt: `${item.created_at}`
                          }
                        }

                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'section-1',
                          position: 'ใต้:ads-billboard',
                          data: {
                            block: '1',
                            title: `อัลบั้ม : ${item.title}`,
                            heading: 'รวมอัลบั้มรูปล่าสุด',
                            index: index + 1
                          }
                        }}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        {/* <WidgetAdsIndex ads={ads} /> */}
        <DynamicAds position={KEY_ADS_POSITION.AD1X1} data={ads} />
                    <div className={`close-box-ads ${!closeAd ? 'close' : 'open'}`}>
                <div onClick={handleCloseBoxAd} className='close-box'>
                  <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />
                </div>
            </div>
      </GalleriesWrapper>
    </>
  );
};
export default GalleryLasted;

const GalleriesWrapper = styled.section`
min-height: 80vh;
  .container {
    max-width: 100%;
  }
  .container-content {
    max-width: 1440px;
    margin: auto;
    padding: 16px;
  }
  
  .heading {
    @media (max-width: 767px) {
    h2 {
      bottom: 10px;
    }
    }
  }
  .ads-slot {
    min-height: 300px;
    @media (max-width: 1025px) {
      min-height: 120px;
    }
  }

  .container {
    padding: 0;
  }
  .grid-wrapper {
    display: grid;
    align-self: center;
    grid-gap: 10px;
    grid-template-columns: 1fr;
    color: #000;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  .block-1 {
    padding-top: 2rem;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  }
  .card-main {
    margin-bottom: 30px;
  }
  .album .img-wrapper {
    cursor: pointer;
    flex: 1 1 25%; /* Flex-grow, flex-shrink, and flex-basis for responsive layout */
    img{ 
      object-fit: cover;
    }
  }
  .album .card-v {
    .card-image {
      aspect-ratio: 1/1;
    }
    h3 {
      font-size: 14px;
      font-weight: 400;
    }
  }
  .album .img {
    width: 100%;
    max-width: 100%;
    aspect-ratio: 1/1;
    object-fit: cover;
    /* margin: 0 0 20px 0; */
    border-radius: 20px;
  }

  .album .img.img-big {
    height: 50%;
    margin: 0 0 16px 0;
    aspect-ratio: 1/1;
    object-fit: cover;
  }

  .album .responsive-container-block.bg {
    max-width: 1440px;
    margin: auto;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 320px));
    gap: 30px;
      img {
        position: relative;
        aspect-ratio: 1/1;
        object-fit: cover;
      }
    @media (max-width: 768px) {
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      .img-wrapper {
        max-width: 100%;
      }
    }
  }

  .album .responsive-container-block.bg {
    flex-direction: column;
  }
`;
